module.exports = __webpack_public_path__ + "img/img-insuranceContract.ebf5204e.png";